<script>
import Page from '@/components/elements/Page';
import PageIntro from '@/components/elements/PageIntro';
import moment from 'moment';
// import VueCountryCode from 'vue-country-code';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import 'vue-tel-input/dist/vue-tel-input.css';

export default {
    name: 'signupInformation',
    components: { Page, PageIntro, VuePhoneNumberInput },
    data() {
        return {
            IDTYPE: 1,
            IDNUMBER: '',
            PHONENUMBER: '',
            EMAIL: '',
            CONTACTMETHODNR: '1',
            BATCHNR: '',
            LOCATIONFIRSTVAC: 'Location',
            DATEFIRSTVAC: null,
            DATEFIRSTVAC2: null,
            reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
            errormessage: '',
            invalidIDNumberError: this.$t('message.error.AanmeldingInformation.InvalidIDNumber') + '\n\r',
            DATEFIRSTVACDD: '03',
            DATEFIRSTVACMM: '02',
            DATEFIRSTVACYYYY: '2021',
            selectIdType: [],
            days: [this.$t('day'), '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
            months: [this.$t('month'), '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
            years: [this.$t('year'), '2021', '2022'],
            locations: ['SAMBIL', 'WTC', 'SEHOS', 'SDK'],
            consent: this.$t('components.AanmeldingInformation.consent'),
            isconsent: false,
            fetching: null,
            maxIdnumber: null,
            DAILCODE: null,
            DEFAULTCOUNTRYCODE: null,
            phoneresults: null
        }
    },
    methods: {
        onSelect({ name, iso2, dialCode }) {
            this.DAILCODE = dialCode;
            // console.log(name, iso2, dialCode);
        },
        isNumber: function(evt) {
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((this.IDTYPE === '1') || (this.IDTYPE === '2')) {
                if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            } else {
                if (this.IDTYPE === '3') {
                    if (charCode === 32) {
                        evt.preventDefault();
                    } else {
                        return true;
                    }
                } else {
                    return true;
                }
            }
        },
        isNumberPhone: function(evt) {
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        allowNoSpace: function(evt) {
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (charCode === 32) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        isNumeric: function(val) {
            return !isNaN(parseFloat(val)) && isFinite(val);
        },
        isDate: function(val) {
            var date = moment(val, 'MM-DD-YYYY');
            return date.isValid();
        },
        validateFirstVacDateDays() {
            const firstdate = this.DATEFIRSTVACYYYY + this.DATEFIRSTVACMM + this.DATEFIRSTVACDD;
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.$store.state.accToken}`
            }
            this.$axios
                .get(this.$config.apiacthealth + 'Personalias/ValidateVacDate/' + firstdate,
                    { headers })
                .then(response => {
                    this.info = response.data;
                    if (this.info === 1) {
                        this.ValidateForm();
                    } else {
                        this.$store.commit('modal/set', {
                            messageHead: this.$t('message.error.InvalidVaccinatieDateDays.head'),
                            messageBody: this.$t('message.error.InvalidVaccinatieDateDays.body'),
                            closeButton: true
                        });
                    }
                }).catch(error => {
                    if (error.response) {
                        const status = error.response.status;
                        switch (status) {
                        case 401:
                            alert('Error 401');
                            break;
                        case 403:
                            alert('Error 403');
                            break;
                        default:
                            this.$store.commit('modal/set', {
                                messageHead: this.$t('message.error.providerInfoNotFound.head'),
                                messageBody: this.$t('message.error.providerInfoNotFound.body'),
                                closeButton: true
                            });
                            alert('Unhandled exception. Please call administrator.\n\r');
                        }
                    }
                })
        },
        submitForm() {
            this.fetching = true;
            this.DAILCODE = this.phoneresults.countryCallingCode;
            this.DEFAULTCOUNTRYCODE = this.phoneresults.countryCode;
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.$store.state.accToken}`
            }
            this.$axios
                .post(this.$config.apiacthealth + 'Signup', { IDTYPE: this.IDTYPE, IDNUMBER: this.IDNUMBER, PHONENUMBER: this.DAILCODE + this.PHONENUMBER, EMAIL: this.EMAIL, CONTACTMETHODNR: this.CONTACTMETHODNR, BATCHNR: this.BATCHNR, LOCATIONFIRSTVAC: this.LOCATIONFIRSTVAC, DATEFIRSTVAC: this.DATEFIRSTVAC2, LANGUAGENR: this.$store.state.languages.current.id },
                    { headers })
                .then(response => {
                    this.$store.state.signupIDTYPE = this.IDTYPE;
                    this.$store.state.signupIdnumber = this.IDNUMBER;
                    this.$store.state.signupDEFAULTCOUNTRYCODE = this.DEFAULTCOUNTRYCODE;
                    this.$store.state.signupPHONENUMBER = this.PHONENUMBER;
                    this.$store.state.signupDAILCODE = this.DAILCODE;
                    this.$store.state.signupEmail = this.EMAIL;
                    this.$store.state.signupCONTACTMETHODNR = this.CONTACTMETHODNR;
                    this.$store.state.signupBATCHNR = this.BATCHNR;
                    this.$store.state.signupLOCATIONFIRSTVAC = this.LOCATIONFIRSTVAC;
                    this.$store.state.signupDATEFIRSTVAC = this.DATEFIRSTVAC;
                    this.$store.state.signupDATEFIRSTVACDD = this.DATEFIRSTVACDD;
                    this.$store.state.signupDATEFIRSTVACMM = this.DATEFIRSTVACMM;
                    this.$store.state.signupDATEFIRSTVACYYYY = this.DATEFIRSTVACYYYY;
                    this.info = response.data
                    if (this.info === '') {
                        this.$router.push({ name: 'signupVerification' });
                    } else {
                        alert(this.info);
                        this.fetching = false;
                    }
                })
                .catch(error => {
                    this.fetching = false;
                    if (error.response) {
                        const status = error.response.status;
                        switch (status) {
                        case 401:
                            alert('Error 401');
                            break;
                        case 403:
                            alert('Error 403');
                            break;
                        default:
                            this.$store.commit('modal/set', {
                                messageHead: this.$t('message.error.providerInfoNotFound.head'),
                                messageBody: this.$t('message.error.providerInfoNotFound.body'),
                                closeButton: true
                            });
                        }
                    }
                })
        },
        ValidateForm() {
            this.errormessage = '';
            this.validateIDNumber();
            this.validateEmailAddress();
            this.validateFirstVacDate();
            if (this.errormessage === '') {
                this.submitForm();
            } else {
                this.$store.commit('modal/set', {
                    messageHead: this.$t('message.error.InvalidVaccinatieDateDays.head'),
                    messageBody: this.errormessage,
                    closeButton: true
                });
            }
        },
        validateIDNumber() {
            if ((this.IDTYPE === '1') || (this.IDTYPE === '3')) {
                if ((this.IDNUMBER.length !== 10) && (this.IDTYPE === '1')) {
                    this.errormessage += this.$t('message.error.AanmeldingInformation.InvalidIDNumber') + '\n\r';
                } else {
                    if (this.IDTYPE === '1') {
                        let birthdate = this.IDNUMBER.substring(0, 8);
                        if (this.isNumeric(birthdate) === true) {
                            birthdate = birthdate.substring(4, 6) + '-' + birthdate.substring(6, 8) + '-' + birthdate.substring(0, 4);
                            if (this.isDate(birthdate) === false) {
                                this.errormessage += this.$t('message.error.AanmeldingInformation.InvalidIDNumber') + '\n\r';
                            };
                        } else {
                            this.errormessage += this.$t('message.error.AanmeldingInformation.InvalidIDNumber') + '\n\r';
                        }
                    } else {
                        if (this.IDTYPE === '1') {
                            if (this.isNumeric(this.IDNUMBER) === false) {
                                this.errormessage += this.$t('message.error.AanmeldingInformation.InvalidIDNumber') + '\n\r';
                            }
                        }
                    }
                }
            } else {
                this.errormessage += this.$t('message.error.AanmeldingInformation.selectIDType') + '\n\r';
            }
        },
        validateEmailAddress() {
            if (this.isEmailValid() === false) {
                this.errormessage += this.$t('message.error.AanmeldingInformation.InvalidEmail') + '\n\r';
            }
        },
        validateFirstVacDate() {
            const firstdate = this.DATEFIRSTVACMM + '-' + this.DATEFIRSTVACDD + '-' + this.DATEFIRSTVACYYYY;
            if ((firstdate.length >= 8) && (firstdate.length <= 10)) {
                if (this.isDate(firstdate) === false) {
                    this.errormessage += this.$t('message.error.AanmeldingInformation.InvalidVaccinatieDate') + '\n\r';
                } else {
                    var now = new Date();

                    if (moment(firstdate, 'MM-DD-YYYY').toISOString().split('T')[0].toString().replaceAll('-', '') > now.toISOString().split('T')[0].toString().replaceAll('-', '')) {
                        this.errormessage += this.$t('message.error.AanmeldingInformation.InvalidVaccinatieDateFuture') + '\n\r';
                    } else {
                        this.DATEFIRSTVAC2 = firstdate;
                    }
                };
            } else {
                this.errormessage += this.$t('message.error.AanmeldingInformation.InvalidVaccinatieDate') + '\n\r';
            }
        },
        isEmailValid: function() {
            return (this.EMAIL === '') ? '' : (this.reg.test(this.EMAIL));
        },
        back() {
            this.$router.push({ name: 'ChoiceProofCW' })
        },
        selectIdnumber() {
            this.IDNUMBER = '';
            switch (this.IDTYPE) {
            case '1':
                this.maxIdnumber = 10;
                break;
            case '2':
                this.maxIdnumber = 10;
                break;
            case '3':
                this.maxIdnumber = 25;
                break;
            }
        }
    },
    mounted() {
        this.$store.state.aanMeldingVerify = false;
        if (this.$store.state.userConsent !== true) {
            this.$router.push({ name: 'Home' });
        };
        this.EMAIL = this.$store.state.signupEmail;
        this.IDTYPE = this.$store.state.signupIDTYPE;
        this.IDNUMBER = this.$store.state.signupIdnumber;
        if (this.$store.state.signupDEFAULTCOUNTRYCODE === null) {
            this.DEFAULTCOUNTRYCODE = 'CW'
        } else {
            this.DEFAULTCOUNTRYCODE = this.$store.state.signupDEFAULTCOUNTRYCODE;
        }
        this.PHONENUMBER = this.$store.state.signupPHONENUMBER;
        this.DAILCODE = this.$store.state.signupDAILCODE;
        this.CONTACTMETHODNR = this.$store.state.signupCONTACTMETHODNR;
        this.BATCHNR = this.$store.state.signupBATCHNR;
        this.LOCATIONFIRSTVAC = this.$store.state.signupLOCATIONFIRSTVAC;
        this.DATEFIRSTVACDD = this.$store.state.signupDATEFIRSTVACDD;
        this.DATEFIRSTVACMM = this.$store.state.signupDATEFIRSTVACMM;
        this.DATEFIRSTVACYYYY = this.$store.state.signupDATEFIRSTVACYYYY;
        this.DATEFIRSTVAC = this.$store.state.signupDATEFIRSTVAC;
    }
}
</script>

<template>
 <Page @back="back">
         <div class="section">
               <PageIntro
                :head="$t('views.InformationAanmelding.pageHeader')"
                :intro="$t('views.InformationAanmelding.pageIntro')"/>
                    <div class="section-block">
                        <h5>{{ $t('components.AanmeldingInformation.preface') }}</h5>
                        <h5 style="margin-top:50px;">{{ $t('components.AanmeldingInformation.firstvaccinationInfoTitle') }}</h5>
                        <label>{{ $t('components.AanmeldingInformation.idtype') }}</label>
                        <select v-model="IDTYPE" v-on:change="selectIdnumber">
                            <option value="0">{{ $t('idtype') }}</option>
                            <option value="1">{{ $t('views.InformationAanmelding.idcard') }}</option>
                            <option value="3">{{ $t('views.InformationAanmelding.passport') }}</option>
                        </select>
                        <label v-if="IDTYPE == 1">{{ $t('components.AanmeldingInformation.idnumber') }}</label>
                        <label v-else-if="IDTYPE == 3">{{ $t('components.AanmeldingInformation.passport') }}</label>
                        <label v-else></label>
                        <input @keypress="isNumber($event)" v-bind:maxlength="maxIdnumber" :disabled="IDTYPE == null" v-model="IDNUMBER" id="input--idnumber" type="text" />
                        <label>{{ $t('components.AanmeldingInformation.contactMethod') }}</label>
                        <div>
                            <input type="radio" id="contactmethod_email" value="1" v-model="CONTACTMETHODNR">
                            <label for="contactmethod_email">Email</label>
                        </div>
                        <div>
                            <input type="radio" id="contactmethod_phone" value="2" v-model="CONTACTMETHODNR">
                            <label for="contactmethod_phone">Phone</label>
                        </div>
                        <label>{{ $t('components.AanmeldingInformation.batchnumber') }}</label>
                        <input  @keypress="allowNoSpace"  v-model="BATCHNR" id="input--batchnumber" type="text" maxlength="25" />
                        <label>{{ $t('components.AanmeldingInformation.datefirstvaccination') }}</label>
                        <div>
                            <div class="datePart" style="display: inline-block;">
                                <label>{{ $t('views.InformationAanmelding.day') }}:</label> <select v-model="DATEFIRSTVACDD" class="smallDropDown">
                                 <option v-for="day in days" :key="day">
                                    {{ day }}
                                 </option>
                                </select>
                            </div>
                            <div class="datePart" style="display: inline-block;margin-left:8px;margin-right:8px;">
                                <label>{{ $t('views.InformationAanmelding.month') }}:</label><select v-model="DATEFIRSTVACMM" class="smallDropDown">
                                 <option v-for="month in months" :key="month">
                                    {{ month }}
                                 </option>
                                </select>
                            </div>
                            <div class="datePart" style="display: inline-block">
                                <label>{{ $t('views.InformationAanmelding.year') }}:</label><select v-model="DATEFIRSTVACYYYY" class="smallDropDown">
                                 <option v-for="year in years" :key="year">
                                    {{ year }}
                                 </option>
                                </select>
                            </div><br>
                            <h5 style="margin-top:50px;">{{ $t('components.AanmeldingInformation.personalInfoTitle') }}</h5>
                            <label>{{ $t('components.AanmeldingInformation.phonenumber') }}</label><br>
                            <div><VuePhoneNumberInput :translations="{
  countrySelectorLabel: $t('country'),
  countrySelectorError: 'Choisir un pays',
  phoneNumberLabel: $t('telephonenumber'),
  example: $t('example')
}" class="phoneInputwrapper" @update="phoneresults = $event" :show-code-on-list=true :border-radius="0" id="PHONENUMBER" :no-example=false :default-country-code="DEFAULTCOUNTRYCODE" v-model="PHONENUMBER" :preferred-countries="['CW', 'AW', 'BQ','NL','US']" /></div>
                            <!-- <div>
                                <div style="float:left"><vue-country-code @update="PhoneUpdate($event)" ref="input--phonenumber" @onSelect="onSelect" :enabledCountryCode="true" :preferredCountries="['cw', 'aw', 'bq','nl','us']"></vue-country-code></div>
                                <div style="float:left"><input @keypress="isNumberPhone($event)" v-model="PHONENUMBER" id="input--phonenumber" type="text" /></div>
                            </div> -->
                            <br><br>
                            <label>{{ $t('components.AanmeldingInformation.email') }}</label>
                            <input v-model="EMAIL" id="input--email" type="text" />
                        </div>
                    <div class="UserConsent">
                        <input type="checkbox" id="checkbox" v-model="isconsent" /><label v-html=" $t('components.AanmeldingInformation.consent') " ></label>
                    </div>
                    <div class="submit">
                        <button v-if="EMAIL && IDNUMBER && BATCHNR && isconsent && phoneresults.isValid" class="buttonAanmelding" @click="validateFirstVacDateDays">{{ $t('next') }}</button><br>
                        <div v-text="$t('onemoment')" v-if="fetching" class="OnemomentText"></div>
                    </div>
                </div>
         </div>
 </Page>
</template>

<style lang="scss">
@import "@/styles/variables/index";
@import "@/styles/input";
@import "@/styles/typography";
@import "@/styles/aanmelding";

.phoneInputwrapper
    .input-tel {
        height: 40px;

        &__label {
            position: absolute;
            top: -20px;
            cursor: pointer;
            left: 13px;
            transform: translateY(25%);
            opacity: 0;
            transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
            font-size: 11px;
        }
    }

    .country-selector {
          height: 50px;

        &__label {
            position: absolute;
            top: -20px;
            cursor: hand;
            left: 22px;
            transform: translateY(25%);
            opacity: 0;
            transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
            font-size: 11px;
        }

        &__country-flag {
            margin: auto 0;
            position: absolute;
            top: 1px;
            left: 1px;
            z-index: 1;
            cursor: pointer;
            img {
                position: absolute;
            }
        }

        .country-selector__input {
        height: 40px;
        min-height: 40px;
        font-size: 12px;
      }

      .country-selector__label {
        top: -22px;
        font-size: 10px;
      }

}

.ProvideTestCode {

    .UserConsent {
        margin-bottom: $length-s;
    }

    .OnemomentText {
        display: block;
        margin: 20px;
        padding-block: 30px;
        font-weight: bold;
    }

    .datePart {
        display: inline-block;
        width: 150px;
    }

    .smallDropDown {
        width: 30px;
    }

}

  .OnemomentText {
        display: block;
        margin: 20px;
        padding-block: 30px;
        font-weight: bold;
    }

.UserConsent {
    padding: 20px;
    background: $color-lightgrey;
    border-radius: 12px;
    display: flex;
    align-items: center;
    margin-top: 20px;

    input[type=checkbox] {
        width: 28px;
        height: 28px;
        margin-right: 20px;
        border-radius: 3px;
        border: 1px solid $color-coronacheck_black;
        cursor: pointer;
    }

    label {
        width: calc(100% - 48px);
        cursor: pointer;
    }
}

</style>
